import { LogOut, User } from 'lucide-react'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/auth-store'
import { queryClient } from '@/lib/query-client'

export function Topbar() {
  const { user, clear, currentTenant: tenant } = useAuthStore()

  async function handleLogout() {
    await supabase.auth.signOut()
    queryClient.clear()
    clear()
  }

  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-background px-6">
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-foreground">
          {tenant?.name ?? 'Dashboard'}
        </span>
        {tenant?.slug && (
          <span className="rounded-full bg-accent px-2 py-0.5 text-xs text-accent-foreground">
            @{tenant.slug}
          </span>
        )}
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <User className="h-4 w-4" />
          <span>{user?.email}</span>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 rounded-md px-3 py-1.5 text-sm text-muted-foreground hover:bg-accent hover:text-accent-foreground"
        >
          <LogOut className="h-4 w-4" />
          <span>Keluar</span>
        </button>
      </div>
    </header>
  )
}
